export const NAME = "core-form";
